export default __webpack_public_path__ + "static/media/teamHeader.ac9825a3.jpg";